import sessionExpiredModalEn from "./locales/en.json";

export const SESSION_EXPIRED_MODAL_NS = "sessionExpiredModal" as const;

export const SessionExpiredModalI18n = {
  en: {
    [SESSION_EXPIRED_MODAL_NS]: {
      ...sessionExpiredModalEn,
    },
  },
};
